import { render } from "./LegalBar.vue?vue&type=template&id=e4eb0eee&scoped=true"
import script from "./LegalBar.vue?vue&type=script&lang=js"
export * from "./LegalBar.vue?vue&type=script&lang=js"

import "./LegalBar.vue?vue&type=style&index=0&id=e4eb0eee&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4eb0eee"]])

export default __exports__